module.exports = __webpack_public_path__ + "static/media/money2.a6558a94.jpg";